import { render, staticRenderFns } from "./MenusManage.vue?vue&type=template&id=b9bedd9c&scoped=true&"
import script from "./MenusManage.vue?vue&type=script&lang=js&"
export * from "./MenusManage.vue?vue&type=script&lang=js&"
import style0 from "./MenusManage.vue?vue&type=style&index=0&id=b9bedd9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bedd9c",
  null
  
)

export default component.exports